// LinkSubstringHashtag.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { SanitizedLink as Link } from '../component/SanitizedLink.jsx';
import { ButtonId } from '../resource/trackingConstants.js';
import { color } from '../style/variables.js';

export const LinkSubstringHashtag = ({ hashtag = '', via = 'flix' }) => {
  const hashtagText = hashtag.replace(/[#＃]/g, '').trim();
  return (
    <StyledLinkSubstringHashtag
      to={`/hashtag/${hashtagText}/${via}`}
      data-element_id={ButtonId.All.ButtonHashtag}
      data-tracking_payload={{
        'hashtag.content': hashtagText,
      }}
    >
      {hashtag}
    </StyledLinkSubstringHashtag>
  );
};

LinkSubstringHashtag.propTypes = {
  hashtag: PropTypes.string,
  via: PropTypes.string,
};

const StyledLinkSubstringHashtag = styled(Link)`
  font-size: inherit;
  font-weight: 600;
  line-height: 1;
  color: ${color.tealBlue};
  :hover {
    text-decoration: underline;
    color: ${color.tealBlue_alpha_40};
  }
`;

export default LinkSubstringHashtag;
